import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../../i18n/LangProvider';

type Config = { departments?: unknown[]; dietary?: unknown[]; accessibility?: unknown[]; meals?: unknown[]; teamsLink?: string };

async function handle<T>(res: Response): Promise<T> {
  if (!res.ok) { let m = `Error ${res.status}`; try { const j = await res.json(); m = j.error || m; } catch { /* noop */ } throw new Error(m); }
  return res.json();
}

export default function AdminTeams() {
  const { t } = useT();
  const [cfg, setCfg] = useState<Config>({});
  const [link, setLink] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const c = await handle<Config>(await fetch('/api/reg-config'));
        setCfg(c); setLink(c.teamsLink || '');
      } catch (e) { setError((e as Error).message); }
    })();
  }, []);

  const save = async () => {
    setBusy(true); setError(null); setMsg(null);
    try {
      await handle(await fetch('/api/reg-config-save', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...cfg, teamsLink: link })
      }));
      setMsg('Teams link saved.');
    } catch (e) { setError((e as Error).message); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 pt-36 pb-32">
      <Link to="/admin" className="text-sm text-ink-muted hover:text-ink lowercase">{t('admin.back')}</Link>
      <p className="text-xs tracking-[0.25em] uppercase text-brand-red mt-5 mb-3 font-mono">Teams</p>
      <h1 className="font-display text-5xl md:text-6xl tracking-tight text-ink mb-10">Teams link.</h1>

      <div className="card p-8">
        <p className="font-display text-xl text-ink mb-1">Teams meeting link</p>
        <p className="text-ink-muted text-sm mb-5">Shown on the home page for online attendees. Leave blank to hide the button.</p>
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="https://teams.microsoft.com/l/meetup-join/..."
            className="flex-1 bg-bg-base border border-white/[0.12] rounded-lg px-3 py-2.5 text-sm text-ink outline-none focus:border-brand-red"
          />
          <button onClick={save} disabled={busy} className="bg-brand-red text-white text-sm rounded-lg px-6 py-2.5 disabled:opacity-40 hover:bg-brand-red-soft whitespace-nowrap">
            {busy ? 'Saving…' : 'Save link'}
          </button>
        </div>
        {msg && <p className="mt-4 text-emerald-400 text-sm">{msg}</p>}
        {error && <p className="mt-4 text-red-400 text-sm">{error}</p>}
      </div>
    </div>
  );
}
